import { render, staticRenderFns } from "./AddEmployeeComponent.vue?vue&type=template&id=1a5f7f8e&scoped=true"
import script from "./AddEmployeeComponent.vue?vue&type=script&lang=js"
export * from "./AddEmployeeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f7f8e",
  null
  
)

export default component.exports